/**
 * Кольцевой буфер диагностических логов звонка + pub/sub для UI-панели
 * (см. CallDebugPanel в packages/main). Не связан с console.* — существующие
 * console.debug/console.log в хуках LiveKit трогать не нужно, эти события
 * дублируются сюда точечно, только там, где важно видеть их на экране
 * устройства без доступа к devtools (iPad/iPhone).
 */
const MAX_ENTRIES = 300;
let entries = [];
let nextId = 1;
const listeners = new Set();
function notify() {
    listeners.forEach((listener) => listener(entries));
}
export function pushCallDebugLog(scope, message, data, level = 'info') {
    const entry = { id: nextId++, time: Date.now(), level, scope, message, data };
    entries = entries.length >= MAX_ENTRIES ? [...entries.slice(1), entry] : [...entries, entry];
    notify();
}
export function subscribeCallDebugLog(listener) {
    listeners.add(listener);
    listener(entries);
    return () => {
        listeners.delete(listener);
    };
}
export function clearCallDebugLog() {
    entries = [];
    notify();
}
export function getCallDebugLogSnapshot() {
    return entries;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FsbERlYnVnTG9nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL3V0aWxzL2NhbGxEZWJ1Z0xvZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7O0dBTUc7QUFjSCxNQUFNLFdBQVcsR0FBRyxHQUFHLENBQUM7QUFFeEIsSUFBSSxPQUFPLEdBQXdCLEVBQUUsQ0FBQztBQUN0QyxJQUFJLE1BQU0sR0FBRyxDQUFDLENBQUM7QUFDZixNQUFNLFNBQVMsR0FBRyxJQUFJLEdBQUcsRUFBMEMsQ0FBQztBQUVwRSxTQUFTLE1BQU07SUFDYixTQUFTLENBQUMsT0FBTyxDQUFDLENBQUMsUUFBUSxFQUFFLEVBQUUsQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztBQUNyRCxDQUFDO0FBRUQsTUFBTSxVQUFVLGdCQUFnQixDQUM5QixLQUFhLEVBQ2IsT0FBZSxFQUNmLElBQThCLEVBQzlCLFFBQTJCLE1BQU07SUFFakMsTUFBTSxLQUFLLEdBQXNCLEVBQUUsRUFBRSxFQUFFLE1BQU0sRUFBRSxFQUFFLElBQUksRUFBRSxJQUFJLENBQUMsR0FBRyxFQUFFLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7SUFDakcsT0FBTyxHQUFHLE9BQU8sQ0FBQyxNQUFNLElBQUksV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM3RixNQUFNLEVBQUUsQ0FBQztBQUNYLENBQUM7QUFFRCxNQUFNLFVBQVUscUJBQXFCLENBQUMsUUFBZ0Q7SUFDcEYsU0FBUyxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUN4QixRQUFRLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDbEIsT0FBTyxHQUFHLEVBQUU7UUFDVixTQUFTLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQzdCLENBQUMsQ0FBQztBQUNKLENBQUM7QUFFRCxNQUFNLFVBQVUsaUJBQWlCO0lBQy9CLE9BQU8sR0FBRyxFQUFFLENBQUM7SUFDYixNQUFNLEVBQUUsQ0FBQztBQUNYLENBQUM7QUFFRCxNQUFNLFVBQVUsdUJBQXVCO0lBQ3JDLE9BQU8sT0FBTyxDQUFDO0FBQ2pCLENBQUMifQ==